import { alpha } from "@mui/material/styles";
import { SystemColors } from "../palette/colors";
// Gray
export const Gray100 = `0 0 0 4px ${alpha(SystemColors.gray["500"], 0.2)}`;
export const Gray100Shadow = `0 0 0 4px ${alpha(SystemColors.gray["500"], 0.2)}, 0px 1px 2px 0px ${alpha(SystemColors.gray["900"], 0.06)}`;
// Primary
export const Primary100 = `0 0 0 4px ${alpha(SystemColors.accentBlue["500"], 0.2)}`;
export const Primary100Shadow = `0 0 0 4px ${alpha(SystemColors.accentBlue["500"], 0.2)}, 0px 1px 2px 0px ${alpha(SystemColors.gray["900"], 0.06)}`;
export const Primary100Full = `0 0 0 4px ${SystemColors.accentBlue["500"]}, 0px 1px 2px 0px ${alpha(SystemColors.gray["900"], 0.06)}`;
// Error
export const Error100 = `0 0 0 4px ${alpha(SystemColors.error["500"], 0.2)}`;
export const Error100Shadow = `0 0 0 4px ${alpha(SystemColors.error["500"], 0.2)}, 0px 1px 2px 0px ${alpha(SystemColors.gray["900"], 0.06)}`;
// Warning
export const Warning100 = `0 0 0 4px ${alpha(SystemColors.warning["500"], 0.2)}`;
export const Warning100Shadow = `0 0 0 4px ${alpha(SystemColors.warning["500"], 0.2)}, 0px 1px 2px 0px ${alpha(SystemColors.gray["900"], 0.06)}`;
// Success
export const Success100 = `0 0 0 4px ${alpha(SystemColors.success["500"], 0.2)}`;
export const Success100Shadow = `0 0 0 4px ${alpha(SystemColors.success["500"], 0.2)}, 0px 1px 2px 0px ${alpha(SystemColors.gray["900"], 0.06)}`;

//# sourceMappingURL=focusRing.js.map